// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22FUa","newExpiryDate":"styles_newExpiryDate__zJE0e","footer":"styles_footer__3L9dt"};